export const ATTANDANCE_OPEN = 'ATTANDANCE_OPEN';
export const ATTANDANCE_CLOSE = 'ATTANDANCE_CLOSE';
